export default "__VITE_ASSET__E$r4tFiu__"